export enum DESCRIPTION_EVENT_TYPE {
  ERG = 'ERG',
  LEARNING = 'Learning',
  OFFSITE = 'Offsite',
  ONBOARDING = 'Onboarding',
  PANEL = 'Panel',
  SOCIAL = 'Social',
  SUMMIT = 'Summit',
  TEAM_BUILDING = 'Team Building',
  TEAM_MEETING = 'Team Meeting',
  TRAINING = 'Training',
  TOWN_HALL = 'Town Hall',
  WEBINAR = 'Webinar',
  WELLNESS = 'Wellness',
  WORKSHOP = 'Workshop',
  VOLUNTEERING = 'Volunteering',
  OTHER = 'Other'
}

export enum DESCRIPTION_TONE {
  CASUAL = 'Casual',
  CONVERSATIONAL = 'Conversational',
  ELEVATED = 'Elevated',
  EMOTIONAL = 'Emotional',
  EXCITED = 'Excited',
  FORMAL = 'Formal',
  FRIENDLY = 'Friendly',
  FUN = 'Fun',
  INSPIRATIONAL = 'Inspirational',
  OTHER = 'Other'
}

// This will get mapped to appropriate word length in backend
export enum DESCRIPTION_LENGTH {
  SHORT = 'Short',
  MEDIUM = 'Medium',
  LONG = 'Long'
}

export enum DESCRIPTION_EDIT_ENUMS {
  SIMPLIFY = 'Simplify',
  SHORTEN = 'Shorten',
  Extend = 'Extend',
  Rephrase = 'Rephrase',
  SPELLING_GRAMMAR = 'Spelling & Grammar',
  EMOJIFY = 'Emojify'
}
